"use client";

import React from "react";

import { StoreSelector } from "~/bff/types/StoreSelector";
import { Nullable } from "~/types/general.types";

interface StoreSelectorContextProps extends StoreSelector {
  isSelectorOpenExt?: boolean;
  setIsSelectorOpenExt?: (isOpen: boolean) => void;
}

export const StoreSelectorContext =
  React.createContext<Nullable<StoreSelectorContextProps>>(null);
